import { createSelector } from 'reselect';

import { Client, ClientType, IClient } from '@packlink/packlink-sdk';

import { IAppState } from '@store/reducers';

const getClientId = (client: Client): string => client?.id || '';

const isInvoiceAddressValid = (state: IAppState): boolean => {
    if (!state.client) {
        return false;
    }

    return (
        state.client.type === ClientType.AUTONOMOUS ||
        (state.client.taxId !== '-' && state.client.type === ClientType.BUSINESS)
    );
};

export const isInvoiceAddressValidState = createSelector(
    [isInvoiceAddressValid],
    (isValid: boolean): boolean => isValid,
);

export const getClient = createSelector([(state: IAppState): IClient => state.client], (client: IClient) =>
    Client.deserialize(client),
);

export const getClientIdentifier = createSelector(getClient, getClientId);
